import "./GetInvolved.module.css";
import Header from "@/reusable_sections/Header";
import Conservation from "./sections/Conservation";
import Inquiry from "./sections/Inquiry";
import Reach from "./sections/Reach";
import Footer from "@/reusable_sections/Footer";
export default function GetInvolvedPage() {
  return <div>
      <Header />
      <Conservation />
      <Inquiry />
      <Reach />
      <Footer />
    </div>;
}